import ReactDOMServer from "react-dom/server";
import {
    Map as LeafletMap,
    DomEvent as LeafletDomEvent,
    DomUtil as LeafletDomUtil,
    Control as LeafletControl
} from "leaflet";
import { createControlComponent } from "@react-leaflet/core";
import { PointIcon } from "../../components/PointIcon";
import { MuiSportsScoreIcon } from "../../components/mui";

export const ToPointControlView = createControlComponent(({ position }) => {
    const control = new LeafletControl({ position });
    control.onAdd = (map: LeafletMap) => {
        const div = LeafletDomUtil.create("div");
        div.innerHTML = ReactDOMServer.renderToString((
            <PointIcon className="to_point text-danger">
                <MuiSportsScoreIcon />
            </PointIcon>
        ));
        LeafletDomEvent.on(div, "click", () => {
            map.fireEvent("update", { custom: "moveToPoint" });
        });
        return div;
    };
    return control;
});
